(() => {
  'use strict';
  const read = id => JSON.parse(document.getElementById(id).textContent);
  const config = read('urban-config');
  const initial = read('urban-catalog');
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const endpoint = path => root + path.replace(/^\//, '');
  const categoryOrder = ['Hats', 'Skincare', 'Fashion & Lifestyle Accessories', 'Hair Care', 'Collectibles & Toys', 'Makeup & Beauty Accessories', 'Body & Personal Care', 'Pet Supplies'];
  function classify(p) {
    if (categoryOrder.includes(p.categoryOverride)) return p.categoryOverride;
    const tags = p.tags || [];
    const categoryTag = tags.find(t => t.startsWith('urban-category:'))?.slice(15);
    if (categoryOrder.includes(categoryTag)) return categoryTag;
    if (window.URBAN_CATEGORY_MAP?.[p.handle]) return window.URBAN_CATEGORY_MAP[p.handle];
    const text = `${p.fullTitle} ${p.type}`.toLowerCase();
    if (/straw hat|sun hat|boater hat|fedora/.test(text) || tags.includes('type:hat')) return 'Hats';
    if (/dog toy|pet toy|pupp/.test(text)) return 'Pet Supplies';
    if (/blind box|nanoblock|building set/.test(text)) return 'Collectibles & Toys';
    if (/hair|shampoo|scalp|unove/.test(text)) return 'Hair Care';
    if (/body lotion|ceramide ato lotion|handy dandy cream|hand cream|shower gel|body wash|wet tissue|toothbrush/.test(text)) return 'Body & Personal Care';
    if (/eyeliner|\blip\b|cheek tint|blotting paper|cushion|pillowcase/.test(text)) return 'Makeup & Beauty Accessories';
    if (/necklace|choker|scarf|shoe light|dinosaur plush head mask|baseball cap|earring|temporary tattoo/.test(text)) return 'Fashion & Lifestyle Accessories';
    return window.URBAN_CATEGORY_MAP?.[p.handle] || 'Skincare';
  }
  function normalize(p) {
    p.category = classify(p);
    p.title ||= p.fullTitle;
    p.images ||= [];
    p.variants = p.variants.map(v => ({...v, id: String(v.id), stock: v.stock === null ? Infinity : Number(v.stock), minimum: Math.max(1, v.minimum || 1), increment: Math.max(1, v.increment || 1)}));
    return p;
  }
  async function request(path, body, {accept = 'application/json'} = {}) {
    const response = await fetch(endpoint(path), {
      method: body === undefined ? 'GET' : 'POST', credentials: 'same-origin',
      signal: AbortSignal.timeout(20000),
      headers: {'Accept': accept, ...(body === undefined ? {} : {'Content-Type':'application/json'})},
      ...(body === undefined ? {cache:'no-store'} : {body: JSON.stringify(body)})
    });
    let data;
    try { data = await response.json(); } catch { throw new Error('We could not connect to the store. Please try again.'); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'This update could not be completed. Please try again.');
    return data;
  }
  const catalogPromise = (async () => {
    const all = initial.products || [];
    // Follow every Liquid pagination page; never silently cap the catalog at 250.
    for (let page = 1; page <= initial.pages; page++) {
      if (page === initial.page) continue;
      // Alternate Liquid views contain JSON but must be requested as HTML.
      // Accept: application/json makes Shopify return a 404 for this route.
      const next = await request(`collections/all?view=urban-data&page=${page}`, undefined, {accept: 'text/html'});
      if (!Array.isArray(next.products)) throw new Error('Product data is unavailable. Please reload.');
      all.push(...next.products);
    }
    if (config.product) all.push(config.product);
    return [...new Map(all.map(p => [p.handle, normalize(p)])).values()].filter(p => p.variants.length);
  })();
  window.UrbanShop = {config, root, endpoint, request, normalize, categoryOrder, catalogPromise, initialCart: read('urban-cart')};
})();
